import React, { useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { BiImageAdd } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import CategoryService from "../../services/category.service";
import { useFormik } from "formik";
import * as yup from "yup";
import { notifyError, notifySuccess } from "../../hook/notification";
import useDialogState, { Loader } from "../../hook";
import MultiImageService from "../../services/multiimage.service";
import Multi4DImageService from "../../services/multi4Dimage.service";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import NotificationService from "../../services/notification.service";
import wallpaper3DService from "../../services/3Dwallpaper.service";
import CollectionService from "../../services/collection.service";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative" ref={menuRef}>
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue}
      </div>
      <div
        className={`${
          toggleShow ? "block" : "hidden"
        } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <p
              key={index}
              onClick={() => {
                onSelect(option.label, option.value);
                setToggleShow(false);
              }}
              className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
            >
              {option.label}
            </p>
          ))
        ) : (
          <p className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white">
            No data found
          </p>
        )}
      </div>
    </div>
  );
};

const MultiWallpaper3D = () => {
  const menuRef = useRef();
  const navigate = useNavigate();
  const [showVal, setShowVal] = useState("NON PREMIUM");
  const [showVal2, setShowVal2] = useState("");
  const [showVal3, setShowVal3] = useState("");
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [collectionData, setCollectionData] = useState([]);
  const [addImageCount, setAddImageCount] = useState(1);
  const [listLayerMulti4DImages, setListLayerMulti4DImages] = useState(
    [...Array(1)].map(() => ({
      preview: "",
      layers: ["", "", ""],
    }))
  );

  const sendNotification = (e) => {
    setNotification(e.target.checked);
  };

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleSelect = (value, id) => {
    setShowVal(value);
    formik.setFieldValue("premium", id === "PREMIUM" ? true : false);
  };

  const handleSelect2 = (value, id) => {
    formik.setFieldValue("categoryId", id);
    setShowVal2(value);
  };

  const handleSelect3 = (value, id) => {
    formik.setFieldValue("collectionId", id);
    setShowVal3(value);
  };

  const handleClick = (index, layerIndex) => {
    const inputRef = document.getElementById(
      `file-input-${index}-${layerIndex}`
    );
    inputRef.click();
  };

  const handleChange = (event, rowIndex, layerIndex) => {
    const fileUploaded = event.target.files[0];
    setListLayerMulti4DImages((prevImages) => {
      const updatedImages = [...prevImages];
      if (layerIndex === -1) {
        updatedImages[rowIndex] = {
          ...updatedImages[rowIndex],
          preview: fileUploaded,
        };
      } else {
        updatedImages[rowIndex].layers[layerIndex] = fileUploaded;
      }

      formik.setFieldValue(`image`, true);
      return updatedImages;
    });
  };

  const handleAdd = () => {
    setAddImageCount(addImageCount + 1);
    setListLayerMulti4DImages((prevImages) => [
      ...prevImages,
      { preview: "", layers: ["", "", ""] },
    ]);
  };

  const removelayout = (indexData) => {
    if (addImageCount > 0) {
      setAddImageCount(addImageCount - 1);
      setListLayerMulti4DImages((prevImages) =>
        prevImages.filter((_, index) => index !== indexData)
      );
    }
  };

  const ImageType = [
    { value: "PREMIUM", label: "PREMIUM" },
    { value: "NON PREMIUM", label: "NON PREMIUM" },
  ];

  const getAllData = async () => {
    const response = await CategoryService.GetAllCategory(0, 0);
    const data = response.data.apiresponse.data;
    setData(data.categories);
  };

  const getAllCollectionData = async () => {
    try {
      const response = await CollectionService.GetAllCollection(0, 0);
      const data = response.data.apiresponse.data;
      setCollectionData(data?.collections);
    } catch (error) {
      console.log("🚀  getAllCollectionData  error:", error);
    }
  };

  useEffect(() => {
    getAllData();
    getAllCollectionData();
  }, []);

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  const initialValue = {
    categoryId: "",
    imageName: "",
    premium: false,
    image: "",
    collectionId: "",
  };

  const schema = yup.object().shape({
    imageName: yup.string().required("Please enter image name"),
    image: yup.mixed().required("Please select image"),
    premium: yup.boolean().required("Please select image type"),
    // categoryId: yup.string().required("Please select image category"),
  });

  const submit = async (values, action) => {
    const { categoryId, imageName, premium, collectionId } = values;
    try {
      // const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
      const fileData = new FormData();
      fileData.append("categoryId", categoryId || 0);
      fileData.append("imageName", imageName);
      fileData.append("premium", premium);
      fileData.append("collectionId", collectionId || 0);
      listLayerMulti4DImages.map((item, index) => {
        // fileData.append(`image[${index}].layer1`, item.layers[0]);
        fileData.append(`image[${index}].previewImage`, item.preview);
      });
      fileData.append("sendNotification", notification);
      setLoader();
      await wallpaper3DService.createMulti3DWallpaper(fileData);
      // if (notification) {
      //   await NotificationService.sendNotification(notification);
      // }
      notifySuccess("Add images successfully");
      setTimeout(() => {
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    } catch (error) {
      console.error("create error", error);
      notifyError("Something went wrong");
      setTimeout(() => {
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <form onSubmit={formik.handleSubmit}>
          <h1 className="titles">Multi 4D Images</h1>
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Name</label>
            <input
              className="input"
              name="imageName"
              placeholder="image name"
              value={formik.values.imageName}
              onChange={formik.handleChange}
              type="text"
            />
            {formik.errors.imageName && formik.touched.imageName && (
              <div className="text-red text-sm">{formik.errors.imageName}</div>
            )}
          </div>

          {/* First Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Type</label>
            <Dropdown
              options={ImageType}
              onSelect={(value, id) => handleSelect(value, id)}
              selectedValue={showVal}
            />
            {formik.errors.premium && formik.touched.premium && (
              <div className="text-red text-sm">{formik.errors.premium}</div>
            )}
          </div>

          {/* Second Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Category</label>
            <Dropdown
              options={CategoryOption}
              onSelect={(value, id) => handleSelect2(value, id)}
              selectedValue={showVal2}
            />
            {formik.errors.categoryId && formik.touched.categoryId && (
              <div className="text-red text-sm">{formik.errors.categoryId}</div>
            )}
          </div>

          {/* Third Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Collection</label>
            <Dropdown
              options={CollectionOption}
              onSelect={(value, id) => handleSelect3(value, id)}
              selectedValue={showVal3}
            />
            {formik.errors.collectionId && formik.touched.collectionId && (
              <div className="text-red text-sm">
                {formik.errors.collectionId}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <div className="flex justify-between items-center">
              <label className="label">List Of Layer Image</label>
              <div
                onClick={handleAdd}
                className="bg-white p-3 rounded-6 cursor-pointer"
              >
                <FaPlus className="bg-transparent" />
              </div>
            </div>
            {[...Array(addImageCount)].map((_, index) => (
              <div key={index} className="flex gap-5 items-center pb-6">
                <h1 className="text-white text-lg font-medium">{index + 1}.</h1>
                <div className="flex gap-4 w-full overflow-x-auto">
                  <div className="w-full">
                    <div className="flex items-center gap-2 w-full">
                      <span className="text-white text-base font-medium min-w-20">
                        Preview 1{" "}
                      </span>
                      <div
                        onClick={() => handleClick(index, -1)}
                        className="w-full border-2 border-dashed border-blue rounded-6 flex justify-center cursor-pointer"
                      >
                        <div>
                          <input
                            type="image"
                            accept="video/mp4"
                            id="upload"
                            hidden
                          />
                          <label className="flex justify-center items-center gap-2 p-2 cursor-pointer w-full h-40">
                            <BiImageAdd className="text-blue text-2xl " />
                            <span className="text-white text-base font-medium w-full text-center">
                              {listLayerMulti4DImages[index]?.preview ? (
                                "Success"
                              ) : (
                                <>
                                  <strong>Upload a file</strong> or drag and
                                  drop mp4
                                </>
                              )}
                            </span>
                          </label>
                        </div>
                      </div>
                      <input
                        id={`file-input-${index}-${-1}`}
                        type="file"
                        onChange={(e) => handleChange(e, index, -1)}
                        className="hidden"
                        accept="video/mp4"
                      />
                    </div>
                    {formik.errors.image && formik.touched.image && (
                      <div className="text-red text-sm">
                        {formik.errors.image}
                      </div>
                    )}
                  </div>

                  {/*  {[...Array(1)].map((_, layerIndex) => (
                    <div key={`layer-${index}-${layerIndex}`}>
                      <div className="flex items-center gap-2">
                        <span className="text-white text-base font-medium">
                          Depth
                        </span>
                        <input
                          type="image"
                          accept="image/*"
                          id="upload"
                          hidden
                        />
                        <label
                          onClick={() => handleClick(index, layerIndex)}
                          className="border-2 border-dashed border-blue rounded-6 flex items-center gap-2 p-2 cursor-pointer"
                        >
                          <BiImageAdd className="text-blue text-2xl" />
                          <span className="text-white text-base font-medium line-clamp-1 w-[65px]">
                            {listLayerMulti4DImages[index]?.layers[layerIndex]
                              ? "Success"
                              : "Upload"}
                          </span>
                        </label>
                        <input
                          id={`file-input-${index}-${layerIndex}`}
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleChange(e, index, layerIndex)}
                          className="hidden"
                        />
                      </div>
                    </div>
                  ))} */}
                </div>
                <MdDeleteOutline
                  onClick={() => removelayout(index)}
                  className="text-red text-3xl cursor-pointer"
                />
              </div>
            ))}
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="notificaiton"
              className="p-3"
              onChange={sendNotification}
            />
            <label
              htmlFor="notificaiton"
              className="text-white ps-4 cursor-pointer"
            >
              Send Notification
            </label>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn save">
              {loader ? <Loader /> : "Save"}
            </button>
          </div>
        </form>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default MultiWallpaper3D;
